import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

// components
import ToggleBtn from '../atom/toggleBtn/ToggleBtn'

// styles
import colors from '../../styles/colors'

export default function ToggleMenu({
  toggleData,
  updateDelivery,
  updateHappyOrder,
}) {
  const [dTrue, setDTrue] = useState(toggleData.delivery)
  const [happyTrue, setHappyTrue] = useState(toggleData.happyOrder)

  useEffect(() => {
    setDTrue(toggleData.delivery)
    setHappyTrue(toggleData.happyOrder)
  }, [toggleData])

  return (
    <ToggleMenuWrapper>
      <Container>
        <Wrapper>
          <LabelText>배달</LabelText>
          <ToggleBtn
            yn={dTrue}
            setYn={(flag) => {
              updateDelivery(flag)
              setDTrue(flag)
            }}
            id={'del'}
            toggleText={'onOff'}
          />
        </Wrapper>
        <Wrapper isLast={true}>
          <LabelText>해피오더</LabelText>
          <ToggleBtn
            yn={happyTrue}
            setYn={(flag) => {
              updateHappyOrder(flag)
              setHappyTrue(flag)
            }}
            id={'happy'}
            toggleText={'onOff'}
          />
        </Wrapper>
      </Container>
    </ToggleMenuWrapper>
  )
}
const ToggleMenuWrapper = styled.div`
  width: 100%;
  min-width: 320px;
  max-width: 477px;
  margin-right: 30px;
  padding: 35px 30px 35px 15px;

  height: 98px;
  object-fit: contain;
  border-radius: 15px;
  box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.1);
  background-color: ${colors.W1};
  display: flex;
  justify-content: center;
  align-items: center;

  @media ${(props) => props.theme.tablet} {
    max-width: 482px;
    margin-right: 20px;
  }

  @media (max-width: 800px) {
    align-self: center;
    margin: 0 0 20px;
    padding: 35px 20px 35px 15px;
  }

  @media ${(props) => props.theme.mobile} {
    max-width: 320px;
    height: 95px;
    padding: 23px 33px 20px;
  }
`

const LabelText = styled.span`
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${colors.G4};
  margin-right: 10px;

  @media ${(props) => props.theme.mobile} {
    font-size: 12px;
    text-align: left;
    color: ${colors.BK};
    margin-bottom: 10px;
  }
`

const Container = styled.div`
  display: flex;
  width: 100%;
  padding: 0 18px 0 36px;
  justify-content: space-between;

  @media ${(props) => props.theme.mobile} {
    padding: 0;
  }
`

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: ${(props) => !props.isLast && '22px'};

  @media ${(props) => props.theme.mobile} {
    flex-direction: column;
    align-items: flex-start;
  }
`
